export default "__VITE_ASSET__Ci3fesC$__"